var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_71_2818",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 58C0 90.0325 25.9675 116 58 116C90.0325 116 116 90.0325 116 58C116 25.9675 90.0325 0 58 0C25.9675 0 0 25.9675 0 58ZM104.4 58C104.4 83.626 83.626 104.4 58 104.4C32.374 104.4 11.6 83.626 11.6 58C11.6 32.374 32.374 11.6 58 11.6C83.626 11.6 104.4 32.374 104.4 58Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 58C0 90.0325 25.9675 116 58 116C90.0325 116 116 90.0325 116 58C116 25.9675 90.0325 0 58 0C25.9675 0 0 25.9675 0 58ZM104.4 58C104.4 83.626 83.626 104.4 58 104.4C32.374 104.4 11.6 83.626 11.6 58C11.6 32.374 32.374 11.6 58 11.6C83.626 11.6 104.4 32.374 104.4 58Z",
    stroke: "#E9EFF1",
    strokeWidth: 18.2593,
    mask: "url(#path-1-inside-1_71_2818)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 5.8C58 2.59675 60.6031 -0.0300361 63.7904 0.28976C69.4207 0.854681 74.9486 2.24159 80.1956 4.41499C87.2325 7.32977 93.6264 11.602 99.0122 16.9878C104.398 22.3736 108.67 28.7675 111.585 35.8044C113.758 41.0514 115.145 46.5794 115.71 52.2097C116.03 55.3969 113.403 58 110.2 58C106.997 58 104.437 55.3933 104.038 52.2151C103.522 48.1094 102.458 44.0825 100.868 40.2435C98.5362 34.614 95.1184 29.4989 90.8098 25.1903C86.5011 20.8816 81.386 17.4638 75.7565 15.132C71.9175 13.5418 67.8906 12.4779 63.785 11.962C60.6067 11.5627 58 9.00325 58 5.8Z",
    fill: "#F40049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderImg);
export default __webpack_public_path__ + "static/media/LoaderImg.5ca0cd8793e42999ac3904be922b87f8.svg";
export { ForwardRef as ReactComponent };